import { Tab, Tabs } from '@mui/material';
import { Calendar, Element3, HambergerMenu, Map1, RowHorizontal } from 'givepulse-iconsax-react';
import { useTranslation } from 'react-i18next';

export enum ViewType {
  LIST = 0,
  GRID = 1,
  CAROUSEL = 2,
  CALENDAR = 3,
  MAP = 4,
}

// gah, gotta stop re-factoring. re-export for now.
export type ViewsType = ViewType;

export const checkViewType = (value?: string) => {
  switch (value) {
    case 'list':
      return ViewType.LIST;
    case 'grid':
      return ViewType.GRID;
    case 'calendar':
      return ViewType.CALENDAR;
    case 'map':
      return ViewType.MAP;
  }
};

const views = [
  {
    view: ViewType.LIST,
    icon: <HambergerMenu />,
    label: 'List View',
  },
  {
    view: ViewType.GRID,
    icon: <Element3 />,
    label: 'Grid View',
  },
  {
    view: ViewType.CALENDAR,
    icon: <Calendar />,
    label: 'Calendar View',
  },
  {
    view: ViewType.MAP,
    icon: <Map1 />,
    label: 'Map View',
  },
  {
    view: ViewType.CAROUSEL,
    icon: <RowHorizontal />,
    label: 'Carousel View',
  },
] as const;

/** Only these views are unusable with a screen reader, so only they get the hint. */
const VIEWS_WITH_SCREEN_READER_HINT: ViewsType[] = [ViewType.CALENDAR, ViewType.MAP];

type IconTabsProps = {
  tabs: ViewsType[];
  onClick: (view: ViewsType) => void;
  currentView: ViewsType;
};

const IconTabs = ({ tabs, onClick, currentView }: IconTabsProps) => {
  const { t } = useTranslation();

  const handleClick = (view: ViewsType) => {
    if (onClick) {
      onClick(view);
    }
  };

  return (
    <>
      {/* new theme has tabs styled to design spec, align with current impl */}
      <Tabs value={currentView} slotProps={{
        indicator: { sx: { height: 0 } }
      }}>
        {views.map(item => {
          if (!tabs.includes(item.view)) {
            return null;
          }

          return (
            <Tab
              value={item.view}
              sx={{
                minWidth: 48,
                '&.Mui-selected': { color: 'primary.main' },
              }}
              key={item.view}
              onClick={() => handleClick(item.view)}
              icon={item.icon}
              aria-label={
                VIEWS_WITH_SCREEN_READER_HINT.includes(item.view)
                  ? `${t(item.label)} - ${t('use List or Grid View')}`
                  : t(item.label)
              }
            />
          );
        })}
      </Tabs>
    </>
  );
};

export default IconTabs;
